import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {Box, Center, HStack, Image, Text} from "@hosttools/frontend/components";
import type {Listing} from "@hosttools/frontend/models/listing";
import {ListingIcon} from "@hosttools/frontend/react/components/Icons";
import type React from "react";
import {memo, useMemo} from "react";

const boxStyle = tva({
    base: "border-2 border-solid border-white rounded"
});

interface ListingImagesProps {
    listing: Listing;
}

const ListingImages: React.FC<ListingImagesProps> = ({listing}) => {
    const displayImages = useMemo(() => listing.images?.slice(0, 2) ?? [], [listing.images]);
    const remainingCount = useMemo(
        () => (listing.images?.length ?? 0) - 2,
        [listing.images?.length]
    );

    return (
        <HStack>
            {!displayImages.length && (
                <Box className={boxStyle({})}>
                    <ListingIcon size="2xl" />
                </Box>
            )}
            {displayImages.map((image, index) => (
                <Box
                    key={image.url}
                    className={boxStyle({})}
                    style={{transform: `translateX(-${index * 8}px)`}}
                >
                    <Image
                        alt={`Listing image ${index + 1}`}
                        className="rounded"
                        size="2xs"
                        source={{uri: image.url}}
                    />
                </Box>
            ))}
            {remainingCount > 0 && (
                <Box
                    className={boxStyle({})}
                    style={{transform: `translateX(-${displayImages.length * 8}px)`}}
                >
                    <Center
                        className={`w-8
                            h-8 
                            bg-blue-50
                            rounded
                        `}
                    >
                        <Text color="blue.600" variant="xs">
                            +{remainingCount}
                        </Text>
                    </Center>
                </Box>
            )}
        </HStack>
    );
};

export default memo(ListingImages);
